// extracted by mini-css-extract-plugin
export default {"headline":"TopNavbarMenu_headline__OP3ch","fadeIn":"TopNavbarMenu_fadeIn__UgnhB"};